import { Badge } from "@merge-api/merge-javascript-shared";
import { DiffExecutionResults } from "./entities";

interface ModelDiffBadgesProps {
  diffResults: DiffExecutionResults;
}

export const ModelDiffBadges = ({ diffResults }: ModelDiffBadgesProps) => {
  const {
    total_different_models = 0,
    total_net_new_models = 0,
    total_net_missing_models = 0,
    total_same_models = 0,
  } = diffResults;

  const hasDifferences =
    total_different_models > 0 || total_net_new_models > 0 || total_net_missing_models > 0;

  if (!hasDifferences) {
    return <Badge color="gray">No changes</Badge>;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {total_same_models > 0 && <Badge color="gray">{total_same_models} models same</Badge>}
      {total_different_models > 0 && (
        <Badge color="yellow">{total_different_models} models different</Badge>
      )}

      {total_net_new_models > 0 && (
        <Badge color="blue">{total_net_new_models} models net new</Badge>
      )}

      {total_net_missing_models > 0 && (
        <Badge color="purple">{total_net_missing_models} models net missing</Badge>
      )}
    </div>
  );
};
